export default __webpack_public_path__ + "static/media/Maya.fe7624ed.JPEG";